var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-position"},[(_vm.required)?_c('div',{staticClass:"text-muted small optional-label"},[_vm._v("Optional")]):_vm._e(),_c('div',{class:[{ 'quill--mini': _vm.mini }],on:{"click":function($event){$event.stopPropagation();return (() => {}).apply(null, arguments)}}},[_c('div',{ref:"toolbar"}),_c('div',{ref:"editor"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }